export class Pix {
  base64QrCode?: string;
  pixData?: string;
  value?: number;
}
